import { render, staticRenderFns } from "./TransferOnlineContent.vue?vue&type=template&id=236c8204&lang=pug"
import script from "./TransferOnlineContent.vue?vue&type=script&lang=js"
export * from "./TransferOnlineContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports